import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { FilterEnum } from 'Common/FieldEnum';

export const FILTER_VALUES = {
  [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
  [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
  [FilterEnum.VendorId]: GenericEnum.InitialFilterValue,
  [FilterEnum.GroupId_Cat]: GenericEnum.InitialFilterValue,
};



// WEBPACK FOOTER //
// ./src/pages/utilities/helper/updateBidDetails.js